import React, { useEffect } from "react";
import BreadcrumbItem from "../../shared/components/BreadcrumbItem";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import List from "./components/List";
import { usePagination } from "../../shared/hooks/usePagination";
import { handleError } from "../../shared/functions/handleError";
import { IInstitution } from "../../shared/interfaces/institution/IInstitution";
import { InstitutionService } from "./service";

const Institutions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [institutions, setInstitutions] = React.useState<IInstitution[]>([]);
  const {
    pagination,
    setPagination,
    changeFilterHandler,
    handleUpdateList,
    totalPages,
    setTotalPages,
  } = usePagination({
    perPage: 10,
  });
  useEffect(() => {
    InstitutionService.getAll(pagination)
      .then((response) => {
        setInstitutions(response?.data);
        setTotalPages(response?.totalPages);
      })
      .catch(handleError);
  }, [pagination, setTotalPages]);

  return (
    <React.Fragment>
      <BreadcrumbItem
        mainTitle={t("institution.institutions")}
        subTitle={t("institution.institutions")}
        buttonTitle={t("institution.addInstitution")}
        onCtaClick={() => navigate("/institutions/create")}
      />
      <List
        institutions={institutions}
        pagination={pagination}
        setPagination={setPagination}
        totalPages={totalPages}
        handleUpdateList={handleUpdateList}
        changeFilterHandler={changeFilterHandler}
      />
    </React.Fragment>
  );
};

export default Institutions;
